import { useMemo } from "react"
import { useUserLoader } from "../../../../../core/users"

import * as Yup from 'yup'

import { FormikDateSelector, FormikSelect, FormikNotesArea } from "../../../../../../components/widgets"
import { useFormikContext, getIn } from "formik"
import { IWebFileAttachment } from "../../../../../core/applications"

// Site Inspection
export interface IDLMSetupInspection  {
  verdict: string 
  workflow: string
  inspectorID: number
  inspectionDate: string
  samplingDate: string
  note: string
  noteAttachments: Array<IWebFileAttachment>
}

export const initDLMSetupInspectionValues: IDLMSetupInspection = {
  verdict: '', 
  workflow: '',
  inspectorID: 0,
  inspectionDate: '',
  samplingDate: '',
  note: '',
  noteAttachments: [],      
}

export const DLMSetupInspectionSchema: any = Yup.object({
  verdict: Yup.string().trim(),    
  workflow: Yup.string().trim(),    
  inspectorID: Yup.number().integer().moreThan(0, 'Select Inspector').required('Select Inspector').label('Inspector'),
  inspectionDate: Yup.string().trim().label('Inspection Date')
  .when(['appState', 'workflow'], {
    is : (appState: string, workflow: string) => (
      (workflow === 'Label5') 
      || ((appState === 'Component Check - Admin Setup') && (workflow === 'Label1b2' || workflow === 'Label1b3') )
      || ((['Sampling Setup','Site Inspection Setup','Testing Setup','Batch Testing Setup'].includes(appState)) && (workflow === 'MandatoryDOC1B') )
    ),
    then: (schema) => schema.required(),
  }),        
  samplingDate: Yup.string().trim().label('Sampling Date')
  .when('workflow', {
    is: (val: string) => (val === 'TriggerTest'),
    then: (schema) => schema.required(),
  }),        
  note: Yup.string().trim().label('Note'),    
  noteAttachments: Yup.array(),         
});



export const DLMSetupInspectionForm = () => {
    
  const { values } = useFormikContext();

  const { workflow, appState } = useMemo(() => {
    if (! values) return { workflow: '', appState: '' };
    const workflow = getIn(values, 'workflow');        
    const appState = getIn(values, 'appState');        
    
    return { workflow, appState };
  }, [values]);


  const { data: inspectors } = useUserLoader({userType: 'DLM Inspector'});
    
  return (
  <>
  <div className="row mb-4">        
    <FormikSelect size="6" label="Assign Inspector" name="inspectorID" required={true} options={inspectors} placeholder='Select Inspector' />
    { ( (workflow === 'Label5') 
      || ((appState === 'Component Check - Admin Setup') && (workflow === 'Label1b2' || workflow === 'Label1b3'))
      || (['Batch Testing Setup','Sampling Setup','Testing Setup','Site Inspection Setup'].includes(appState) && (workflow === 'MandatoryDOC1B'))
      ) && 
    <FormikDateSelector size="6" label="Inspection Date" name="inspectionDate" required={true} showShiftSelector={true} dateFormat="LL" />
    }
    { (workflow === 'TriggerTest') && 
    <FormikDateSelector size="6" label="Sampling Date" name="samplingDate" required={true} showShiftSelector={true} dateFormat="LL" />
    }         
  </div>
  <FormikNotesArea />    
  </>
  )
}